export let BrowserVendor;
(function (BrowserVendor) {
  BrowserVendor["CHROME"] = "Chrome";
  BrowserVendor["FIREFOX"] = "Firefox";
  BrowserVendor["SAFARI"] = "Safari";
  BrowserVendor["EDGE"] = "Edge";
  BrowserVendor["EDGE_CHROMIUM"] = "Edg";
  BrowserVendor["OPERA"] = "Opera";
  BrowserVendor["UNKNOWN"] = "Unknown";
})(BrowserVendor || (BrowserVendor = {}));